import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { PAYLOAD_QUERY } from '@/components/customercenter-ui/components/customer-detail/constants';
import { useCheckout } from '@/context/checkoutProvider';
import Caution from '@/customercenter-ui/icons/caution';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { CardRadioButton } from './CardRadioButton';

const PaymentTitle = ({ data, soldAccountData, creditAccountName, accountSoldOn, isSoldAccount }: any) => {
  const { isNoChargeOrder } = useCheckout();
  const params = useSearchParams();
  const [isDisabled, setIsDisabled] = useState(false);
  const divisionCode = params.get(PAYLOAD_QUERY.DIVISION_CODE) ?? 'ZB';

  useEffect(() => {
    if (soldAccountData) {
      setIsDisabled(true);
    }
  }, [soldAccountData]);

  return (
    <>
      <section>
        <p className="text-lg font-bold leading-6">{mapLocaleToMeaningfulFormat().paymentMethod}</p>
        {!isNoChargeOrder && (
          <p className="pt-0.5 text-xs font-normal leading-4">{mapLocaleToMeaningfulFormat().required}</p>
        )}

        {isNoChargeOrder && <h1>No Charge</h1>}
      </section>
      {!isNoChargeOrder && soldAccountData && (
        <section className="mt-2 flex items-start border-l-[6px] border-l-[#D6A124] bg-[#FFF3E380] p-5">
          <div className="mr-2 shrink-0">
            <Caution className="h-[25px] w-[25px]" />
          </div>
          <div className="font-medium text-[#D6A124]">
            {divisionCode === 'ZD'
              ? mapLocaleToMeaningfulFormat([`${creditAccountName()}`, `${soldAccountData?.name}`])
                  .checkoutAccountSoldMsgZD
              : mapLocaleToMeaningfulFormat([`${creditAccountName()}`, `${soldAccountData?.name}`])
                  .checkoutAccountSoldMsg}{' '}
            {accountSoldOn}. {mapLocaleToMeaningfulFormat().checkoutPaymentMsg}
          </div>
        </section>
      )}
      <section className={!isNoChargeOrder ? 'pt-30' : ''}>
        <CardRadioButton data={data} isDisabled={isDisabled} isSoldAccount={isSoldAccount} />
      </section>
    </>
  );
};

export default PaymentTitle;
